import { IconClose } from '@consta/icons/IconClose'
import { Button } from '@consta/uikit/Button'
import { Text } from '@consta/uikit/Text'
import type { FC } from 'react'

import css from './SidebarHeader.css'
import type { ISidebarHeader } from './types'

export const SidebarHeader: FC<ISidebarHeader> = ({ projectName, closeSidebar }) => {
  return (
    <div className={css.sidebarHeader}>
      <Text size="xl" weight="bold" view="primary">
        {projectName}
      </Text>
      <Button size="s" view="clear" iconRight={IconClose} onlyIcon={true} onClick={closeSidebar} />
    </div>
  )
}
